import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
	Link,
} from 'react-router-dom';
import CONSTANTS from '../../../constants';
import { pushEventToGTM } from '../../../helpers/trackerManager';
import { CurrentStepSetAction } from '../../../actions/action';
import SummarySectionBlock from "../summarySectionBlock";
import InfosMessage from "../infosMessage";
import EditButton from '../../buttons/EditButton';

const mapStateToProps = state => state;
const mapDispatchToProps = { CurrentStepSetAction };

class CarSummary extends PureComponent {
	_isMounted = false;
	static defaultProps = {
		Title: "",
		isWithPrice: false,
	};

	constructor(props) {
		super(props);
		this.state = {
			pageLoaded: false,
			showNextEditButtonCar: false,
		};

	}

	render() {
		const { car, kilo } = this.props.store;
		const carName = car.ModelLabel + ' - ' + car.EnergyLabel;
		return (
			<SummarySectionBlock
				fold={this.props.fold}
				opened={this.props.opend}
				title={CONSTANTS.LABELS.summary_vehicule}>
				<div className="carInfos-summary-block">
					<h3 tabIndex="0" className="block-title">{carName}</h3>
					<ul className={'infos-list' + (Object.values(car).length && !Object.values(car.SerialNumber).length > 0 ? ' half-list' : '')}>
						{Object.values(car).length && Object.values(car.SerialNumber).length > 0 && <li className="list-item">
							<span tabIndex="0" className=" info-block__title">  {CONSTANTS.LABELS.summary_vehicule_vin} : </span>
							<span tabIndex="0"> {car.SerialNumber}</span>
						</li>}
						<li tabIndex="0" className="list-item">
							<span className=" info-block__title"> {CONSTANTS.LABELS.summary_vehicule_km}:</span>
							<span> {kilo.kilometrage} Km</span>
						</li>
						<li tabIndex="0" className="list-item">
							{kilo.contratService && <span className="contrat-info" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.summary_vehicule_warranty_true) }}></span>}

							{!kilo.contratService && <span className="contrat-info" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.summary_vehicule_warranty_false) }}></span>}
						</li>

					</ul>


					{!this.state.showNextEditButtonCar &&
						this.props.isWithPrice &&
						!this.props.store.isEditMode &&
						<EditButton onClick={(e) => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_vehicule'
							});
							this.setState({ showNextEditButtonCar: true });
						}
						} />
					}
					{!this.state.showNextEditButtonCar &&
						this.props.isWithPrice &&
						this.props.store.isEditMode && !this.props.expiredDate &&
						<EditButton onClick={(e) => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_vehicule'
							});
							this.setState({ showNextEditButtonCar: true });
						}
						} />
					}
					{!this.state.showNextEditButtonCar &&
						!this.props.isWithPrice &&
						!this.props.store.isEditMode &&
						<Link onClick={(e) => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_vehicule'
							});
							this.props.CurrentStepSetAction(3)
						}
						}
							to={`${CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}`}>
							<EditButton />
						</Link>}

					{!this.state.showNextEditButtonCar &&
						!this.props.isWithPrice &&
						this.props.store.isEditMode && !this.props.expiredDate &&
						<Link onClick={(e) => {
							pushEventToGTM({
								pageName: 'summary',
								eventAction: 'Redirection::Internal::Modify',
								eventLabel: 'summary_modify_vehicule'
							});
							this.props.CurrentStepSetAction(3)
						}
						}
							to={`${CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}`}>
							<EditButton />
						</Link>}
					{this.state.showNextEditButtonCar &&
						<Link
							to={`${CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}`}
							onClick={(e) => this.props.CurrentStepSetAction(3)}>
							<EditButton Title={CONSTANTS.LABELS.summary_warning1_continue} />
						</Link>}
					{this.state.showNextEditButtonCar &&
						this.props.isWithPrice &&
						<InfosMessage>
							{CONSTANTS.LABELS.summary_warning_alert_vehicle}
						</InfosMessage>}


				</div>
			</SummarySectionBlock>

		)
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(CarSummary);
